// kilometers.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kilometers',
  pure: true
})
export class KilometersPipe implements PipeTransform {
  transform(value: number): string {
    return value.toLocaleString('pt-BR');
  }
}